import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const LightMode = props => {
  const $ = _c(11);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M9.99556 13.0511C11.6831 13.0511 13.0511 11.683 13.0511 9.9955C13.0511 8.30796 11.6831 6.93994 9.99556 6.93994C8.30802 6.93994 6.94 8.30796 6.94 9.9955C6.94 11.683 8.30802 13.0511 9.99556 13.0511Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M9.99554 3.5V4.44" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M5.40222 5.40222L6.06722 6.06722" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M3.5 9.99561H4.44" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M5.40222 14.5888L6.06722 13.9238" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M9.99554 16.4911V15.5511" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M14.5889 14.5888L13.9239 13.9238" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M16.4911 9.99561H15.5511" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M14.5889 5.40222L13.9239 6.06722" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props) {
    t9 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[9] = props;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
};
export default LightMode;